import { createMiddleware, createStart } from "@tanstack/react-start";
import { renderErrorPage } from "./lib/error-page";
import { attachSupabaseAuthSafe } from "./lib/supabase-auth-attacher";

// IMPORTANT: do NOT import `@/integrations/supabase/auth-attacher` here.
// That generated middleware imports the browser Supabase client, which reads
// `localStorage` at module scope. `src/start.ts` runs during SSR, where
// `localStorage` does not exist, so importing it here breaks every page.
// `attachSupabaseAuthSafe` is the intentional, SSR-safe replacement – it loads
// the Supabase client lazily in the browser only. Do not swap it back.


// Catches request-middleware failures before the root route can render.
const errorMiddleware = createMiddleware({ type: "request" }).server(
  async ({ next }) => {
    try {
      return await next();
    } catch (error) {
      if (
        error &&
        typeof error === "object" &&
        "statusCode" in (error as Record<string, unknown>)
      ) {
        throw error;
      }
      console.error(error);
      return new Response(renderErrorPage(), {
        status: 500,
        headers: { "content-type": "text/html; charset=utf-8" },
      });
    }
  },
);

export const startInstance = createStart(() => ({
  functionMiddleware: [attachSupabaseAuthSafe],
  requestMiddleware: [errorMiddleware],
}));
